import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./order_channel.js";
//#region src/order_channel_helper.ts
var order_channel_helper_exports = /* @__PURE__ */ __exportAll({
	isFlash: () => isFlash,
	isKiosk: () => isKiosk,
	isOrderAhead: () => isOrderAhead,
	name: () => name,
	nameCombiningKioskAndFlash: () => nameCombiningKioskAndFlash
});
function name(channel) {
	switch (channel) {
		case "catering": return "Catering";
		case "drive-thru": return "Drive-Thru";
		case "flash": return "Contactless";
		case "kiosk": return "Kiosk";
		case "linebuster": return "Linebuster";
		case "web": return "Web";
	}
}
function nameCombiningKioskAndFlash(channel) {
	switch (channel) {
		case "kiosk": return "Kiosk/Flash";
		case "catering":
		case "drive-thru":
		case "flash":
		case "linebuster":
		case "web": return name(channel);
	}
}
function isOrderAhead(channel) {
	switch (channel) {
		case "catering":
		case "web": return true;
		case "drive-thru":
		case "flash":
		case "kiosk":
		case "linebuster": return false;
	}
}
function isKiosk(channel) {
	switch (channel) {
		case "drive-thru":
		case "linebuster":
		case "kiosk": return true;
		case "catering":
		case "web":
		case "flash": return false;
	}
}
function isFlash(channel) {
	switch (channel) {
		case "catering":
		case "kiosk":
		case "flash":
		case "web": return true;
		case "drive-thru":
		case "linebuster": return false;
	}
}
//#endregion
export { isFlash, isKiosk, isOrderAhead, name, nameCombiningKioskAndFlash, order_channel_helper_exports };

//# sourceMappingURL=order_channel_helper.js.map